{
  "title": "Sunburst",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level evocation",
  "level": 8,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (fire and a piece of sunstone)",
  "duration": "Instantaneous",
  "description": [
    "Brilliant sunlight flashes in a 60-foot radius centered on a point you choose within range. Each creature in that light must make a Constitution saving throw. On a failed save, a creature takes 12d6 radiant damage and is blinded for 1 minute. On a successful save, it takes half as much damage and isn’t blinded by this spell. Undead and oozes have disadvantage on this saving throw.",
    "A creature blinded by this spell makes another Constitution saving throw at the end of each of its turns. On a successful save, it is no longer blinded.",
    "This spell dispels any darkness in its area that was created by a spell."
  ],
  "spellLists": ["cleric", "druid", "sorcerer", "wizard"]
}
